import { PointFeature, PointFeaturesInterface } from './point';

export interface RegionFeature {
  id?: number;
  type: string;
  geometry: {
      type: string;
      coordinates: [number, number][][];
  }
  properties?: {
      name?: string;
      description?: string;
      color?: string;
      points?: {
          type: string;
          features: PointFeature[];
      }
  }
}

export interface RegionFeatures {
    type: string;
    features: RegionFeature[];
}

export class Region {
    private _id?: number;

    constructor(
        public coordinates: [number, number][][], public name: string="", public description: string="", public points: PointFeature[] = [], public color: string=""
    ) {}

    get id(): number | undefined {
        return this._id;
    }

    set id(id: number) {
        this._id = id;
    }
    
    public setPoints(points: PointFeaturesInterface) {
        points.features.forEach(element => {
            let point = new PointFeature(element);
            // point.id = element.id;
            // this.points[point.id] = point;
        });
    }

    public toJson(): RegionFeature {
        return {
            "id": this.id,
            "type": "Feature",
            "geometry" : {
                "type": "Polygon",
                "coordinates": this.coordinates
            },
            "properties": {
                "name": this.name,
                "description": this.description,
                "color": this.color
            }
        }
    }
}
